// Réduction d'une photo dans le navigateur AVANT envoi (4G de chantier) : ≤ 2000 px sur le grand côté, JPEG qualité 0,85.
// L'orientation EXIF est appliquée (photo prise en portrait sur Android). Aucune donnée ne quitte l'appareil ici.

export const COTE_MAX = 2000;
export const QUALITE = 0.85;

async function decoder(fichier: Blob): Promise<{ source: CanvasImageSource; largeur: number; hauteur: number; liberer: () => void }> {
  if ('createImageBitmap' in window) {
    try {
      const b = await createImageBitmap(fichier, { imageOrientation: 'from-image' });
      return { source: b, largeur: b.width, hauteur: b.height, liberer: () => b.close() };
    } catch { /* format non décodé par createImageBitmap : essai avec un élément image */ }
  }
  const url = URL.createObjectURL(fichier);
  try {
    const img = new Image();
    img.decoding = 'async';
    img.src = url;
    await img.decode();
    return { source: img, largeur: img.naturalWidth, hauteur: img.naturalHeight, liberer: () => URL.revokeObjectURL(url) };
  } catch {
    URL.revokeObjectURL(url);
    throw new Error('Cette photo ne peut pas être lue par le navigateur (format non pris en charge). Prenez-la en JPEG.');
  }
}

/** Renvoie une photo JPEG réduite, prête à envoyer. */
export async function reduirePhoto(fichier: Blob, coteMax = COTE_MAX, qualite = QUALITE): Promise<Blob> {
  const { source, largeur, hauteur, liberer } = await decoder(fichier);
  try {
    if (!largeur || !hauteur) throw new Error('Photo vide ou illisible.');
    const echelle = Math.min(1, coteMax / Math.max(largeur, hauteur));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(largeur * echelle));
    canvas.height = Math.max(1, Math.round(hauteur * echelle));
    const c = canvas.getContext('2d');
    if (!c) throw new Error('Réduction de la photo impossible sur cet appareil.');
    c.drawImage(source, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>((ok) => canvas.toBlob(ok, 'image/jpeg', qualite));
    if (!blob) throw new Error('Réduction de la photo impossible sur cet appareil.');
    return blob;
  } finally { liberer(); }
}

/** Corps multipart d'une photo (champ « photo »). */
export function formulairePhoto(photo: Blob, nom = 'photo.jpg') {
  const f = new FormData();
  f.append('photo', photo, nom);
  return f;
}
